export default {"src":"/_next/static/media/accessible.bac1376b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};